// env vars from the cli are always strings, so !!ENV_VAR returns true for "false"
function bool(value) {
  if (value == null) return false;
  return value && value !== "false" && value !== "0";
}

module.exports = bool(process.env["BABEL_8_BREAKING"])
  ? require("to-fast-properties-BABEL_8_BREAKING-true")
  : require("to-fast-properties-BABEL_8_BREAKING-false");
